interface BlockLayoutInfo {
  id: string;
  class: string;
}

export const getBlockLayoutInfo = (type: string, globalId: string): BlockLayoutInfo => {
  return {
    id: `block-${type}-${String(globalId).slice(-10)}`,
    class: `portal-block portal-block-${type}`,
  };
};
